
<script>import Loader from '/app/components/Loader.html'

export default {

	computed: {
		filteredItems: (items, tags) => {
			// filter, truncate, and sort
			if (tags && tags.length) {
				const lowerTags = _.map(tags, tag => tag.toLowerCase())
				items = _.filter(items, item => {
					const foundItemTags = _.filter(_.map(item.tags, tag => tag.toLowerCase()), itemTag => {
						return lowerTags.indexOf(itemTag) > -1
					})
					return foundItemTags.length
				})
			}
			items = _.map(items, item => {
				if (item.summary && item.summary.length > 200) {
					const pieces = item.summary.slice(0, 200).split(' ')
					pieces.pop()
					item.summary = pieces.join(' ') + ' . . .'
				}
				return item
			})
			// return items
			return _.orderBy(items, 'title', 'asc')
		},
	},

	oncreate() {
		this.observe('filteredItems', filteredItems => {
			if (filteredItems.length) {
				const $html = document.querySelector('html')
				const tags = _.map(_.filter($html.classList, item => {
					return item.indexOf('program-page-') > -1
				}), item => item.split('program-page-')[1])
				if (tags.length) {
					this.set({ tags })
				}
			}
		})

		// one time fetch
		fetch('json/sample-programs-list.json')
			.then(response => response.json())
			.then(json => this.set({ items: json }))
			// TODO: handle errors gracefully?
			.catch(ex => console.log('parsing failed', ex))

	},

	components: {
		Loader,
	},

}

</script>
<div class="list">{{#if filteredItems.length}}{{#each filteredItems as item}}
  <div class="media-block">
    <div class="img"><img src="{{item.image}}" alt="{{item.imageAlt}}">{{#if item.online}}
      <div class="option online">Can be completed entirely online</div>{{/if}}
    </div>
    <div class="content">
      <h3 class="title"><a href="{{item.url}}">{{item.title}}</a></h3>{{#if item.list && item.list.length}}
      <ul class="sub-list">{{#each item.list as listItem}}
        <li><a href="{{listItem.url}}">{{listItem.text}}</a></li>{{/each}}
      </ul>{{else}}
      <p>{{item.summary}}</p>{{/if}}
    </div>
  </div>{{/each}}{{else}}
  <Loader></Loader>{{/if}}
</div>